import { component } from "@tento-ui/component-decorators";
import { ChatTermTurn } from "../chat-term-turn";
import type { ChatMessage } from "../chat-types";

// Codex's dialect of the terminal register.
//
// A dialect is exactly one decision — which plugin renders a block — and
// `pluginTypeFor` is the seam the base register declares for it. Everything
// else (the height reporting, the gap vars, the recycle discipline) is
// inherited untouched.
//
// This element is the half of the seam that was missing. The routing below
// used to sit on `ChatTermTurn` itself as the register's default, which is
// what made the codex grammar look like core's: a look that changed nothing
// still rendered `• Ran …`, and any new terminal look inherited a CLI's
// house style it never asked for. The register now routes nothing, and this
// class is the one place that says the codex look draws a turn this way —
// the same shape `ChatClaudeTurn` has had since it was written.
//
// The grammar, from the Codex CLI's own transcript:
//
//     • The click producer is working: selection.ljson advanced …
//     • Ran /Users/james/bin/tsh.dev view 14925
//       └ interactive terminal output
@component({ name: "std-chat-codex-turn" })
export class ChatCodexTurn extends ChatTermTurn {
  protected override pluginTypeFor(
    blockType: string,
    message: ChatMessage,
  ): string {
    if (blockType === "tool_call") return "tool_call_codex";
    if (blockType === "text" && message.role !== "user") return "text_codex";
    return blockType;
  }
}
